import { render, staticRenderFns } from "./quality-assurance-tray-info.vue?vue&type=template&id=0501d9be&scoped=true&"
import script from "./quality-assurance-tray-info.vue?vue&type=script&lang=js&"
export * from "./quality-assurance-tray-info.vue?vue&type=script&lang=js&"
import style0 from "./quality-assurance-tray-info.vue?vue&type=style&index=0&id=0501d9be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501d9be",
  null
  
)

export default component.exports